module.exports = __webpack_public_path__ + "static/media/travel.9d707f10.png";